module.exports = __webpack_public_path__ + "img/dynamic1.59544dfc.png";